import api from '@/api';
import { debounce } from 'lodash-es';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';
import addressMonitor from '@/utils/addressMonitor';
import { trackEvent } from '@/lib/omega';
import { GLOBAL_ADDRESS_CHANGE, eventBus } from '@/utils/eventBus';
import { getAddressLogInfo } from '@/const/logs';
import { plPick } from '@/utils/plPick';
const unique = (arr, val) => {
  const res = new Map();
  return arr.filter(item => !res.has(item[val]) && res.set(item[val], 1));
};

const filterType = (resultArr, type) => {
  return resultArr.filter(item => item.type == type);
};
const realexposure = result => {
  let addressArr = [];
  if (result.deliveryAddress?.address) {
    addressArr.push(result.deliveryAddress?.address);
  }
  if (result.historyAddressList?.length) {
    addressArr = [...addressArr, ...result.historyAddressList];
  }
  let resultArr = unique(addressArr, 'aid');
  return {
    history_num: resultArr?.length || 0,
    home_num: filterType(resultArr, 1).length || 0,
    company_num: filterType(resultArr, 2).length || 0,
  };
};

function temp(cb) {
  cb();
}
const DELAY = 1000;
const debounceRequest = debounce(temp, DELAY);
let LATEST_REQUEST_COUNT = 0;

const state = {
  // 请求loading
  loading: false,

  // 搜索地址的信息
  searchId: '', // search id
  poiList: [], // poi 列表
  address_strategy_version: '', // 地址策略版本

  // 创建地址信息
  addressInfos: {},

  // 获取地址列表数据
  addressStrategyVersion: '',
  deliveryAddress: {}, // 送餐地址
  locationAddress: {},
  historyAddressList: [], // 历史地址

  // lastPoi存储上一次的地址信息
  lastPoi: {},
  lastPoiAid: '',
};
const mutations = {
  // 获取搜索地址的信息
  setAddressSearch(state, data) {
    const { searchId = '', poiList = [], address_strategy_version = '' } = data;
    state.searchId = searchId;
    state.poiList = poiList;
    state.address_strategy_version = address_strategy_version;
  },
  // 创建地址接口
  setAddressCreate(state, data) {
    state.addressInfos = { ...data };
  },
  setAddressDelete(state, data) {},
  // 获取地址信息
  getAddressList(state, data) {
    state.addressStrategyVersion = data?.addressStrategyVersion;
    state.locationAddress = data?.locationAddress;
    state.historyAddressList = data?.historyAddressList;
    state.deliveryAddress = data?.deliveryAddress;
  },
  setLoadingStatus(state, data) {
    state.loading = data.loading;
  },
  setLastPoiState(state, { lastPoi, lastPoiAid }) {
    eventBus.$emit(GLOBAL_ADDRESS_CHANGE);
    if (state?.lastPoi?.countryCode != lastPoi?.countryCode) {
      state.lastPoi = lastPoi;
      state.lastPoiAid = lastPoi?.aid;

      setLocalStorage('lastPoiAid', lastPoi?.aid || '');
      addressMonitor.set(plPick(lastPoi));
      location.reload();
    }

    state.lastPoi = lastPoi;
    state.lastPoiAid = lastPoi?.aid || '';
    setLocalStorage('lastPoiAid', lastPoi?.aid || '');
    addressMonitor.set(plPick(lastPoi));
  },
  getLastPoiState(state) {
    addressMonitor.flush();
    state.lastPoi = addressMonitor.get();
    setLocalStorage('lastPoiAid', state.lastPoi?.aid || '');
    state.lastPoiAid =
      state.lastPoi?.aid || getLocalStorage('lastPoiAid') || '';
  },
  delPoiListState(state) {
    state.poiList = [];
  },
};
const actions = {
  setLoading({ commit }, param) {
    commit('setLoadingStatus', param);
  },
  // 获取搜索地址的信息
  addressTextsearch({ commit, state }, param) {
    state.loading = true;
    // 并发请求下，只保留匹配一致的结果
    ++LATEST_REQUEST_COUNT;
    debounceRequest(async () => {
      let CURRENT_REQUEST_COUNT = LATEST_REQUEST_COUNT;
      try {
        const res = await api.addressTextsearch(param);
        const { current_page, current_path } = getAddressLogInfo();
        if (CURRENT_REQUEST_COUNT === LATEST_REQUEST_COUNT) {
          trackEvent({
            eventId: 'sailing_c_x_deliverydetail_search_sw',
            eventLabel: '地址列表搜索结果曝光',
            attrs: {
              search_term: param?.query,
              associative_words_num: res?.poiList?.length || 0,
              current_page,
              current_path,
            },
          });
          commit('setAddressSearch', res);
        }
      } catch (err) {
        if (CURRENT_REQUEST_COUNT === LATEST_REQUEST_COUNT) {
          commit('setAddressSearch', {});
        }
      }
      state.loading = false;
    });
  },
  // 创建地址接口
  async addressCreate({ commit, state }, param) {
    state.loading = true;
    try {
      const res = await api.addressCreate(param);
      commit('setAddressCreate', res);
    } catch (err) {}
    state.loading = false;
  },

  // 更新地址接口
  async addressUpdate({ commit, state }, param) {
    state.loading = true;
    try {
      const res = await api.addressUpdate(param);
      commit('setAddressCreate', res);
    } catch {}
    state.loading = false;
  },

  // 删除地址接口
  async addressDelete({ commit, state }, param) {
    state.loading = true;
    try {
      const res = await api.addressDelete(param);
      commit('setAddressDelete', res);
    } catch {}
    state.loading = false;
  },

  // 获取地址信息
  async addressList({ commit, state }, param) {
    state.loading = true;
    try {
      const res = await api.addressList(param);
      commit('getAddressList', res);

      trackEvent({
        eventId: 'sailing_c_x_deliverydetail_realexposure_sw',
        eventLabel: '地址列表实曝光',
        attrs: realexposure(res),
      });
    } catch {}
    state.loading = false;
  },
  // 存储lastPoi地址信息
  setLastPoi({ commit }, param) {
    commit('setLastPoiState', param);
  },
  // 获取lastPoi地址信息
  getLastPoi({ commit }) {
    commit('getLastPoiState');
  },
  // 删除当前本地查询的地址信息
  delPoiList({ commit }) {
    commit('delPoiListState');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
